import React from "react";

const Logout = () => {
  localStorage.clear();
  window.location.href = 'https://auth.inabex.net/loginv2/login?backurl=directway.pro/auth/login&logout=true';
  return <></>;
}
export default Logout;

